import { Theme } from "@mui/material"
import { COLORS, DefaultColors } from "./types"

export const getThemeColors = (theme: Theme): Record<COLORS, string | undefined> & { [key in COLORS]: string | undefined } => ({
    "background.default": theme.palette.background.default,
    "background.paper": theme.palette.background.paper,
    text: theme.palette.text.primary,
    "text.primary": theme.palette.text.primary,
    "text.secondary": theme.palette.text.secondary,
    "text.disabled": theme.palette.text.disabled,
    "grey.100": theme.palette.grey[100],
    "grey.200": theme.palette.grey[200],
    "grey.300": theme.palette.grey[300],
    "grey.400": theme.palette.grey[400],
    "grey.500": theme.palette.grey[500],
    "grey.600": theme.palette.grey[600],
    "grey.700": theme.palette.grey[700],
    "grey.800": theme.palette.grey[800],
    "grey.900": theme.palette.grey[900],
    primary: theme.palette.primary.main,
    "primary.main": theme.palette.primary.main,
    "primary.light": theme.palette.primary.light,
    "primary.lighter": theme.palette.primary.lighter,
    "primary.dark": theme.palette.primary.dark,
    "primary.100": theme.palette.primary[100],
    secondary: theme.palette.secondary.main,
    "secondary.main": theme.palette.secondary.main,
    "secondary.light": theme.palette.secondary.light,
    "secondary.dark": theme.palette.secondary.dark,
    "secondary.lighter": theme.palette.secondary.lighter,
    success: theme.palette.success.main,
    "success.main": theme.palette.success.main,
    "success.light": theme.palette.success.light,
    "success.dark": theme.palette.success.dark,
    warning: theme.palette.warning.main,
    "warning.main": theme.palette.warning.main,
    "warning.light": theme.palette.warning.light,
    "warning.dark": theme.palette.warning.dark,
    error: theme.palette.error.main,
    "error.main": theme.palette.error.main,
    "error.light": theme.palette.error.light,
    "error.dark": theme.palette.error.dark,
    info: theme.palette.info.main,
    "info.main": theme.palette.info.main,
    "info.light": theme.palette.info.light,
    "info.dark": theme.palette.info.dark,
    "common.white": theme.palette.common.white,
    "common.black": theme.palette.common.black,
    divider: theme.palette.divider,
})

export const resolveColor = (
    theme: Theme,
    color: COLORS | "default" | "inherit" | "transparent",
    variant?: "main" | "light" | "dark" | "paper" | "default" | "primary" | "secondary",
    useContrastColor?: boolean
) => {
    if (color === "transparent" || color === "inherit") return color
    if (color === "default") return undefined
    const themeColors = getThemeColors(theme)
    const resolved = themeColors[`${color}.${variant}` as COLORS] ?? themeColors[color as COLORS]
    if (useContrastColor && resolved) {
        return theme.palette[color as DefaultColors]?.contrastText ?? theme.palette.augmentColor({ color: { main: resolved } }).contrastText
    }
    return resolved
}
